var ScheduleJobMatchItemActionsModalController = /** @class */ (function () {
    function ScheduleJobMatchItemActionsModalController() {
        // this.actionType = this.resolve.actionType;
        // this.actionLabel = this.resolve.actionLabel;
    }
    ScheduleJobMatchItemActionsModalController.prototype.$onInit = function () {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    ScheduleJobMatchItemActionsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    ScheduleJobMatchItemActionsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    ScheduleJobMatchItemActionsModalController.prototype.onEmployeeAdded = function (employee) {
        if (employee) {
            this.callbackObject.callbackType = this.actionType;
            this.callbackObject.entity = employee;
            this.closeModal();
        }
        else {
            this.dismissModal();
        }
    };
    return ScheduleJobMatchItemActionsModalController;
}());
// import * as TEMPLATE from './schedule-job-match-item-actions-modal.html;
import * as TEMPLATE from 'raw-loader!./schedule-job-match-item-actions-modal.html';
export var ScheduleJobMatchItemActionsModalComponent = {
    selector: 'scheduleJobMatchItemActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ScheduleJobMatchItemActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/scheduleJobMatchItem/scheduleJobMatchItemActionsModal/schedule-job-match-item-actions-modal.html'
    }
};
//# sourceMappingURL=schedule-job-match-item-actions-modal.component.js.map